import React from 'react';

import HeaderLandingPageMobile from './LandingPage/HeaderLandingPage/HeaderLandingPageMobile';
import HeaderLandingPage from './LandingPage/HeaderLandingPage/HeaderLandingPageDesktop';
import FooterLandingPage from './LandingPage/FooterLandingPage';
import MenuDesktop from './MenuDesktop';
import Footer from './Footer';
import ServiceBar from './ServiceBar';
import * as styles from './LayoutLandingPage.module.scss';
import loadable from '@loadable/component';
import { useStaticQueryDataChatMutuo } from '../query/useStaticQueryDataChatMutuo';

const ChatMutuo = loadable(() => import('./ChatMutuo'));

const LayoutLandingPage = ({ children, data, location }) => {
  const acf = data.wpPage.template.acfTemplateLandingPage;
  const isLight = !acf?.versioneLight;
  const { chatMutuo } = useStaticQueryDataChatMutuo();
  const totalDisableChat = chatMutuo?.disattivazioneTotaleChatMutuo;

  if (!isLight) {
    return (
      <>
        <MenuDesktop isHpTemplate={true} isChatMutuoTemplate={false} lightVersion={false} />
        <main className="main main-no-margin-top">{children}</main>
        <div className={styles.footerWrapper}>
          <Footer />
        </div>
        <ServiceBar
          isChatMutuoTemplate={false}
          isHpTemplateLightVersion={false}
          isLandingPageTemplate={true}
          comeFunzionaOverride={acf?.comeFunzionaOverride ?? null}
        />
        {totalDisableChat !== true && <ChatMutuo location={location} />}
      </>
    );
  }

  return (
    <>
      <div className={styles.headerDesktop}>
        <HeaderLandingPage
          headerText={acf.testoHeader?.desktop}
        />
      </div>
      <div className={styles.headerMobile}>
        <HeaderLandingPageMobile
          headerText={acf.testoHeader?.mobile}
        />
      </div>
      <main>{children}</main>
      <FooterLandingPage />
    </>
  );
}

export default LayoutLandingPage;
